// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"bd31ee624f79aeb54afe","691":"3513506ec7dc7c25bbfd"}[chunkId] + ".js";
};